import React, {Component} from 'react';
import Product from './Product';
import {Row} from 'reactstrap';

class Products extends Component {
  render() {
    let products = this.props.products.map(product => {
      return (
        <Product
          addVariantToCart={this.props.addVariantToCart}
          checkout={this.props.checkout}
          product={product}
          more={false}
          key={product.id.toString()}
          style={this.props.style}
          productCount={this.props.products.length}
        />
      );
    });
    return <Row>{products}</Row>;
  }
}

export default Products;



// WEBPACK FOOTER //
// ./src/components/Products.js